import { render, staticRenderFns } from "./StoreProductCardList.vue?vue&type=template&id=3225de48"
import script from "./StoreProductCardList.vue?vue&type=script&lang=js"
export * from "./StoreProductCardList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports